import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { isNullOrUndefined } from '@app/util/util';
import { TravelerTypes } from '@pax/entities/traveler-info';
import { getBookingInfoTypeByTravelBookingType } from '@pax/mappers/get-pax-info-by-types.mapper';

@Pipe({
  name: 'paxOrdinalLabel',
  standalone: false
})
export class PaxOrdinalLabelPipe implements PipeTransform {

  constructor(
    private translation: TranslocoService,
  ) { }

  transform(
    isOrdinal: boolean,
    booking: TravelBookingType,
    travelerType: TravelerTypes = null,
    ordinalKey: string = null,
    travelerAge: number | null = null,
  ): string {
    if (isOrdinal && ordinalKey) {
      const ordinalValue = this.translation.translate(`ORDINALS.${ordinalKey}`);
      const infoTypeValue = this.translation.translate(getBookingInfoTypeByTravelBookingType(booking));
      const travelerTypeValue = this.translation.translate(`BOOKING_MODULE.ITINERARY_PASSENGERS.SINGLE.${travelerType}`);
      if (isNullOrUndefined(travelerAge)) {
        return this.translation.translate('BOOKING_MODULE.PAX.SAVE_PAX_ORDINAL', {
          ordinal: ordinalValue,
          traveler: infoTypeValue,
          // Temporary logic, delete when we receive MinAge and MaxAge in Validate
          type: booking !== TravelBookingType.ACTIVITIES ? travelerTypeValue : '',
        });
      } else {
        const key = getTranslateKey(travelerType, booking, travelerAge);
        return this.translation.translate(key, {
          ordinal: ordinalValue,
          traveler: infoTypeValue,
          type: travelerTypeValue,
          ages: travelerAge,
        });
      }
    } else {
      return this.translation.translate('BOOKING_MODULE.PAX.NEW_PAX',
        {
          traveler: this.translation.translate(getBookingInfoTypeByTravelBookingType(booking))
        }
      );
    }
  }
}

function getTranslateKey(travelerType: TravelerTypes, booking: TravelBookingType, travelerAge: number | null): string {
  const defaultKey = 'BOOKING_MODULE.PAX.SAVE_PAX_ORDINAL';
  switch (travelerType) {
    case TravelerTypes.CHILDREN:
      if (booking === TravelBookingType.HOTELS || booking === TravelBookingType.PACKAGE_AIR) {
        const translateKey = travelerAge < 1 ? 'BOOKING_MODULE.PAX.SAVE_PAX_ORDINAL_WITH_MONTH' :
          travelerAge === 1 ? 'BOOKING_MODULE.PAX.SAVE_PAX_ORDINAL_WITH_AGE' : 'BOOKING_MODULE.PAX.SAVE_PAX_ORDINAL_WITH_AGES';
        return translateKey;
      } else return defaultKey;
    default:
      return defaultKey;
  }
}

